import { Scale } from "lucide-react";
import { useLocation } from "react-router-dom";
import { InboxWithMine } from "@/pages/inbox/InboxWithMine";
import { useRegion } from "@/contexts/RegionContext";

// /legal/inbox follows the region switcher; /aus/legal/inbox is pinned to Australia.
export default function LegalInbox() {
  const { currentRegion } = useRegion();
  const { pathname } = useLocation();
  const region = pathname.startsWith("/aus/") ? "AUS" : currentRegion;
  const link = region === "AUS"
    ? (c) => `/aus/collections/ageing/${c.case_id}`
    : (c) => `/legal/case/${c.case_id}?source=legal`;
  return (
    <InboxWithMine dept="legal" title="Legal Inbox" icon={Scale} testid="legal-inbox-shell" prefix="legal" region={region}
      storageKey="sf_legal_inbox_view" caseLink={link} />
  );
}
